import React, { Component } from 'react'
import { Button, Input, Modal, ModalFooter, ModalHeader } from 'reactstrap';
import PropTypes from 'prop-types';
import './DesmarcarComoPaga.scss';

export default class DesmarcarComoPaga extends Component {
  constructor(props){
    super(props);
    this.state = {
      estaAberto: false,
      data: null,
      motivo: '',
    }
    this.minimoCaracteres = 4;
    this.limiteCaracteres = 1000;
    this.lidarComTeclaEscape = this.lidarComTeclaEscape.bind(this);
  }

  componentDidMount(){
    window.addEventListener('keydown', this.lidarComTeclaEscape);
  }

  componentWillUnmount(){
    window.removeEventListener('keydown', this.lidarComTeclaEscape);
  }
  
  fecharModal(){
    this.setState({motivo: ''});
    this.setState({estaAberto: false});
  }

  /**
   * O metódo é usado pelo componente pai
   */
  abrirModal(dados){
    this.setState({estaAberto: true, data: dados});
  }

  lidarComTeclaEscape(e){
    if(e.key==='Escape'){
      this.fecharModal();
    }
  }

  enviarMotivo(){
    if(this.state.motivo.length < this.minimoCaracteres){
      return;
    }
    this.props.alternarPagamento({...this.state.data, motivo: this.state.motivo});
    this.fecharModal();
  }

  atualizarTextarea(valor){
    const novoValor = valor.substring(0, this.limiteCaracteres);
    this.setState({motivo: novoValor});
  }
  render() {
    return (
      <Modal
        id="modal-desmarcar-paga" 
        size="lg"
        isOpen={this.state.estaAberto}
        centered={true}
        onClosed={this.props.onClosed}
      >
        <ModalHeader className="outstanding">Desmarcar Pagamento</ModalHeader>
        <div className="modal_body">
          <p>Você está prestes a desmarcar uma guia marcada como <strong>"Paga"</strong>. Para prosseguir, informe o motivo da sua ação:</p>
          <Input
            type="textarea"
            value={this.state.motivo}
            onChange={e => this.atualizarTextarea(e.target.value)}
            placeholder="Digite o motivo"
            rows="4"
          />
          <div className="indicador-caracteres">
            <p className='info'><i className="fas fa-info-circle"></i> Pelo menos {this.minimoCaracteres} caracteres</p>
            <p><span className={`${this.state.motivo.length >= this.limiteCaracteres ? 'font-bold' : ''}`}>{this.state.motivo.length}</span>/{this.limiteCaracteres}</p>
            </div>
        </div>
        <ModalFooter>
          <Button color="info" onClick={() => this.fecharModal()}>
            Fechar
          </Button>
          <Button 
            color="success"
            onClick={() => this.enviarMotivo()}
            disabled={this.state.motivo.length < this.minimoCaracteres}
            title={`${this.state.motivo.length < this.minimoCaracteres ? 'Digite pelo menos ' + this.minimoCaracteres + ' caracteres' : ''}`}
          >
            Enviar
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}
DesmarcarComoPaga.propTypes = {
  onClosed: PropTypes.func.isRequired,
  alternarPagamento: PropTypes.func.isRequired,
}
